export default {
  methods: {
    lastFulfilled(fields) {
      // // find me a field without a key set
      let emptyField = fields.find(
        (field) => (!field.label || !field.type) && field.isNew
      );
      let fulfilled = emptyField === undefined ? true : false;
      if (!fulfilled) {
        this.$vs.notify({
          color: "warning",
          title: `Error`,
          text: "Please complete the current field info",
        });
        return false;
      } else {
        return true;
      }
    }
  }
}